export enum GroupsManagementAccessLevelEnum {
  Editable = 'write',
  Invisible = '',
  Visible = 'read',
}

export type GroupsManagementAccessLevel = `${GroupsManagementAccessLevelEnum}`
